module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex sidebar-container"
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft"
    }
  }, [_c('div', {
    staticClass: "sideMenu"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.activeMenu
    },
    on: {
      "open": function($event) {},
      "close": function($event) {}
    }
  }, [(_vm.account.organizationName) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.dashboard')))])])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'profile.account'
      }
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.profile')))])])], 1), _vm._v(" "), _c('router-link', {
    class: {
      'router-link-active': _vm.$route.name && (_vm.$route.name.split('.')[0] == 'clients' || _vm.$route.name.split('.')[0] == 'clientGroups' || _vm.$route.name.split('.')[0] == 'pricingAgreements')
    },
    attrs: {
      "to": {
        name: 'clients.index',
        query: {
          filter: 'active'
        }
      }
    }
  }, [(_vm.hasModule('Client') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.clients')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'router-link-active': _vm.$route.name.split('.')[0] == 'production'
    },
    attrs: {
      "to": {
        name: 'production.batches.index',
        query: {
          filter: 'all'
        }
      }
    }
  }, [(_vm.hasModule('Production') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_c('i', {
    staticClass: "fa fa-industry",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.production')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'router-link-active': _vm.$route.name.split('.')[0] == 'products'
    },
    attrs: {
      "to": {
        name: 'products.index',
        query: {
          filter: 'active'
        }
      }
    }
  }, [(_vm.hasModule('Product') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.products')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'router-link-active': _vm.$route.name.split('.')[0] == 'appointments'
    },
    attrs: {
      "to": {
        name: 'orders.index',
        query: {
          filter: 'created'
        }
      }
    }
  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.orders')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'bills.index'
      }
    }
  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.bills')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'members.index'
      }
    }
  }, [(_vm.hasModule('Appointment') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.members')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'membership.index'
      }
    }
  }, [(!_vm.account.organizationName && _vm.account.organizationMembers.length > 0) ? _c('el-menu-item', {
    attrs: {
      "index": "9"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Membership")])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'campaigns.index'
      }
    }
  }, [(_vm.hasModule('Appointment') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "9"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.newsletter')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    class: {
      'router-link-active': _vm.$route.name.split('.')[0] == 'inventory'
    },
    attrs: {
      "to": {
        name: 'warehouse.index',
        query: {
          filter: 'active'
        }
      }
    }
  }, [(_vm.hasModule('Inventory') && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "12"
    }
  }, [_c('i', {
    staticClass: "fa fa-archive",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.inventory')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.reports')))])]) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'application.settings'
      }
    }
  }, [((_vm.hasModule('EDI') || _vm.hasModule('Appointment')) && _vm.isVerified) ? _c('el-menu-item', {
    attrs: {
      "index": "14"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('layouts.sidebar.settings')))])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "sidebar",
    staticClass: "side-subMenu"
  }, [_vm._l((_vm.innerSidebar), function(section, index) {
    return [(section.title) ? _c('div', {
      key: index
    }, [_c('h4', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('ul', _vm._l((section.options), function(item, index) {
      return _c('router-link', {
        key: index,
        class: {
          'active': (JSON.stringify(item.route.query) || '{}') === JSON.stringify(_vm.$route.query) && item.route.name === _vm.$route.name, 'disabled': _vm.innerSidebarDisabled
        },
        attrs: {
          "to": item.route
        }
      }, [_c('li', [_vm._v(_vm._s(item.title) + " "), (item.detail) ? _c('span', [_vm._v(_vm._s(item.detail))]) : _vm._e()])])
    }), 1), _vm._v(" "), (section.button) ? _c('router-link', {
      class: {
        disabled: _vm.innerSidebarDisabled
      },
      attrs: {
        "to": section.button.route
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(section.button.title))])], 1) : _vm._e(), _vm._v(" "), (index < _vm.innerSidebar.length - 1) ? _c('hr') : _vm._e()], 1) : _vm._e()]
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-close side-subMenu__close-btn hide-desktop",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(false)
      }
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0ee0f6","hasScoped":false}!./src/app/components/sidebar/sidebar.html
// module id = 2935
// module chunks = 1